import axios from "axios"

export const postSolicitudViolencia = async (data: any) => {
  try{
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/demanda-violencia-familiar`, data)
    return response
  }  
  catch(error){
    return error
  }
}
